app.controller("CreateQuestionWindowController", ["$scope", "params", "$uibModalInstance", "StaticData", "QuestionnairesService", "toastr",
    function ($scope, params, $uibModalInstance, StaticData, QuestionnairesService, toastr) {
        $scope.question = params.question || {
            order: params.order+1 || 1,
            type: null,
            title: null,
            description: null,
            mandatory: false,
            questions: [],
            options: [],
            minText: null,
            maxText: null,
            range: 5
        };
        $scope.types = [];
        $scope.answer = null;

        $scope.mode = "create";

        if ($scope.question.type !== null){
            $scope.mode = "edit";
        }

        StaticData.getItemsByKey("questionnaire_types").then(function (types) {
            $scope.types = [{name: 'კითხვის ტიპი'}].concat(types);
            $scope.types.push({name: 'გამყოფი', _id: 'break'});
            $scope.types.push({name: 'სათაური', _id: 'lineTitle'});
        });

        $scope.getPlaceholder = function () {
            if($scope.question.type === 'lineTitle') return 'კომენტარი/სათაური';
            else return 'კითხვა';
        };

        $scope.add = function () {
            if (!$scope.answer) return toastr.error('', 'გთხოვთ ჩაწეროთ სავარაუდო პასუხი');
            if ($scope.question.options.indexOf($scope.answer) === -1)
                $scope.question.options.push({'ans': $scope.answer, value: false});
            $scope.answer = null;
        };

        $scope.submit = function () {
            if (!$scope.question.type) toastr.error('გთხოვთ მიუთითოთ კითხვის ტიპი');
            else if ($scope.question.type === 'container') {
                if (!$scope.question.order) toastr.error('გთხოვთ მიუთითოთ ადგილი');
                else if (!$scope.question.title || !$scope.question.title.length) toastr.error('გთხოვთ მიუთითოთ კომენტარი');
                else $uibModalInstance.close(
                        {
                            type: $scope.question.type,
                            title: $scope.question.title,
                            description: $scope.question.description,
                            mandatory: $scope.question.mandatory,
                            order: $scope.question.order,
                            questions: []
                        }
                    );
            }
            else if (!$scope.question.order) toastr.error('გთხოვთ მიუთითოთ ადგილი');
            else if ($scope.question.type === 'break') {
                $scope.question.title = '----------------------------------------------------------------------------------------------------';
                $uibModalInstance.close($scope.question);
            }
            else if ($scope.question.type === 'lineTitle') {
                if (!$scope.question.title || !$scope.question.title.length) toastr.error('გთხოვთ მიუთითოთ სათაური');
                else $uibModalInstance.close($scope.question);
            }
            else if (!$scope.question.title || !$scope.question.title.length) toastr.error('გთხოვთ მიუთითოთ კითხვა');
            else if ($scope.question.type === 'range' && !$scope.question.minText) toastr.error('გთხოვთ მიუთითოთ მინიმალური');
            else if ($scope.question.type === 'range' && !$scope.question.maxText) toastr.error('გთხოვთ მიუთითოთ მაქსიმალური');
            else if ($scope.question.type !== 'range' && $scope.question.type !== 'text' && $scope.question.type !== 'title' && $scope.question.options.length <= 1) toastr.error('გთხოვთ დაამატოთ სავარაუდო პასუხები');
            else {
                $uibModalInstance.close($scope.question);
            }
        };

        $scope.remove = function (answer) {
            var index = $scope.question.options.indexOf(answer);
            $scope.question.options.splice(index, 1)
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
